import { ResponseReuseType } from '../constants';
import { Task } from '../interfaces';
import { getCookie } from '../../common/utils/cookies';

export const checkIsFullRR = (tcPlusFlow: boolean, fullRRCount: number, tasks: Task[]): boolean => {
  const nonOptionalTasks = tasks.filter((task) => !task.optional);
  return tcPlusFlow ? fullRRCount === tasks.length : fullRRCount === nonOptionalTasks.length;
};

export const checkIfRRAppliedButNotFullRR = (tasks: Task[]): boolean => {
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  let partialRRButNotFullRR = false;
  let fullRRCount = 0;
  for (let i = 0; i < tasks.length; i++) {
    const task = tasks[i];
    if (
      task.responseReuseType === ResponseReuseType.PARTIAL_RR ||
      task.responseReuseType === ResponseReuseType.FULL_RR
    ) {
      partialRRButNotFullRR = true;
    }
    if (task.responseReuseType === ResponseReuseType.FULL_RR) ++fullRRCount;
  }
  const isFullRR = checkIsFullRR(tcPlusFlow, fullRRCount, tasks);
  if (isFullRR) partialRRButNotFullRR = false;

  return partialRRButNotFullRR;
};
